import React, { useEffect, useState } from "react";
import { MessageCircle, X, Phone, Calculator } from "lucide-react";
import { Link } from "react-router-dom";
import { company, serviceOptions } from "../mock";

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [service, setService] = useState(serviceOptions[0]);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 1200);
    return () => clearTimeout(t);
  }, []);

  // Build a context-rich, prefilled message from the visitor's inputs.
  const buildMessage = () => {
    const who = name.trim() ? `Hi BEE Exsellance, my name is ${name.trim()}.` : "Hi BEE Exsellance.";
    return encodeURIComponent(
      `${who} I'd like to enquire about *${service}*. Please could you assist me with my B-BBEE journey?`
    );
  };

  const waLink = `https://wa.me/${company.whatsapp}?text=${buildMessage()}`;

  return (
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3">
      {open && (
        <div className="w-[318px] rounded-2xl overflow-hidden shadow-[0_24px_60px_-20px_rgba(0,0,0,.4)] bg-white border border-slate-100 animate-[fadeUp_.3s_ease]">
          <div className="bg-[#075E54] text-white px-4 py-3 flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-white/15 grid place-items-center">
              <MessageCircle size={20} />
            </div>
            <div className="leading-tight flex-1">
              <div className="font-semibold text-sm">BEE Exsellance</div>
              <div className="text-[11px] text-emerald-100">Typically replies within minutes</div>
            </div>
            <button onClick={() => setOpen(false)} aria-label="Close">
              <X size={18} />
            </button>
          </div>

          <div className="p-4 bg-[#ece5dd]">
            <div className="bg-white rounded-lg rounded-tl-none p-3 text-sm text-slate-700 shadow-sm">
              Hi there! 👋 Tell us a little about yourself and we'll start the chat with the right context.
            </div>
          </div>

          <div className="p-3 space-y-3 bg-white">
            <div>
              <label className="block text-[12px] font-medium text-slate-500 mb-1">Your name</label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. Thandi"
                className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-[#25D366] focus:ring-2 focus:ring-[#25D366]/20 transition"
              />
            </div>
            <div>
              <label className="block text-[12px] font-medium text-slate-500 mb-1">How can we help?</label>
              <select
                value={service}
                onChange={(e) => setService(e.target.value)}
                className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white outline-none focus:border-[#25D366] focus:ring-2 focus:ring-[#25D366]/20 transition"
              >
                {serviceOptions.map((o) => (
                  <option key={o}>{o}</option>
                ))}
              </select>
            </div>

            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 w-full justify-center bg-[#25D366] hover:bg-[#20bd5a] text-white font-semibold py-2.5 rounded-lg transition-colors"
            >
              <MessageCircle size={18} /> Start Chat on WhatsApp
            </a>

            <div className="grid grid-cols-2 gap-2">
              <a
                href={`tel:${company.phones[1].replace(/\s/g, "")}`}
                className="flex items-center gap-1.5 justify-center text-[13px] font-medium text-[#0B1F3A] bg-[#F6F7F9] hover:bg-slate-200 py-2 rounded-lg transition-colors"
              >
                <Phone size={14} /> Call
              </a>
              <Link
                to="/pricing-calculator"
                onClick={() => setOpen(false)}
                className="flex items-center gap-1.5 justify-center text-[13px] font-medium text-[#0B1F3A] bg-[#F6F7F9] hover:bg-slate-200 py-2 rounded-lg transition-colors"
              >
                <Calculator size={14} /> Quote
              </Link>
            </div>
          </div>
        </div>
      )}

      {show && (
        <button
          onClick={() => setOpen((o) => !o)}
          className={`w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg hover:scale-105 transition-transform ${
            open ? "" : "wa-pulse"
          }`}
          aria-label="WhatsApp chat"
        >
          {open ? <X size={26} /> : <MessageCircle size={28} />}
        </button>
      )}
    </div>
  );
}
